















































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import Service from "@/services/RetensiAlihMediaService";
import {
  RetensiSession,
  RetensiDokumen,
  DocStatus,
} from "@/types/RetensiAlihMedia";

@Component({ name: "RetensiStepDokumen" })
export default class StepDokumen extends Vue {
  @Prop({ type: Object, default: null }) session!: RetensiSession | null;

  activeBatch = 0;
  file: File | null = null;
  uploading = false;
  verifying = false;
  verifyDialog = false;
  verifyTarget: RetensiDokumen | null = null;

  upload: Partial<RetensiDokumen> = {
    no_rm: "",
    nama_pasien_snapshot: "",
    kategori_nilai_guna: "transient",
    scan_resolution_dpi: 300,
  };

  verifyForm = {
    halaman_terverifikasi: 0,
    pmik_verifikator_id: 0,
    pmik_verifikator_nama: "",
    watermark_applied: false,
  };

  nilaiGunaOpts = [
    { value: "permanent", text: "Permanen" },
    { value: "transient", text: "Transient (musnah ≥25 thn)" },
    { value: "legal_hold", text: "Legal Hold" },
  ];

  get batches() {
    return this.session?.batches ?? [];
  }

  docStatusColor(s: DocStatus | undefined): string {
    return (
      ({
        preliminary: "grey",
        final: "green",
        superseded: "orange",
        entered_in_error: "red",
      } as Record<string, string>)[s ?? "preliminary"] || "grey"
    );
  }

  async doUpload(batch: any) {
    if (!this.file) return;
    this.uploading = true;
    try {
      const fd = new FormData();
      fd.append("file", this.file);
      for (const [k, v] of Object.entries(this.upload)) {
        if (v !== null && v !== undefined && v !== "") {
          fd.append(k, String(v));
        }
      }
      await Service.uploadDokumen(batch.id, fd);
      this.file = null;
      this.upload.no_rm = "";
      this.upload.nama_pasien_snapshot = "";
      this.$emit("refresh");
    } finally {
      this.uploading = false;
    }
  }

  openVerify(d: RetensiDokumen) {
    this.verifyTarget = d;
    this.verifyForm.halaman_terverifikasi = d.halaman_total ?? 0;
    this.verifyForm.watermark_applied = !!d.watermark_applied;
    this.verifyDialog = true;
  }

  async doVerify() {
    if (!this.verifyTarget) return;
    this.verifying = true;
    try {
      await Service.verifyDokumen(this.verifyTarget.id!, this.verifyForm);
      this.verifyDialog = false;
      this.$emit("refresh");
    } finally {
      this.verifying = false;
    }
  }

  async deleteDok(id: number | undefined) {
    if (!id || !confirm("Hapus dokumen ini?")) return;
    await Service.deleteDokumen(id);
    this.$emit("refresh");
  }
}
